import '@/scss/common/carousel.scss'
import './hero-carousel.scss'
import { Carousel, CmsImage } from '@omnia/ui/src/lib'
import type { FC } from 'react'
import { CtaButton } from '@/common/components/ctaButton/CtaButton'
import type { HeroCarouselPropsApi } from '@/common/components/heroCarousel/models'

interface HeroCarouselProps {
    items: HeroCarouselPropsApi[]
}

const HeroCarousel: FC<HeroCarouselProps> = ({ items }) => {
    if (items.length === 0) return null
    const hasMultipleItems = items.length > 1
    return (
        <div className="container-lg-padding hero-carousel">
            <Carousel
                config={{
                    showPositionIndicators: hasMultipleItems,
                    disableScroll: !hasMultipleItems,
                    autoPlay: {
                        active: hasMultipleItems,
                        stopOnInteraction: true,
                    },
                    settings: {
                        loop: true,
                        slidesToScroll: 1,
                        duration: 25,
                    },
                }}
            >
                {items.map((item, index) => (
                    <div className="hero-carousel__item" key={index}>
                        <CmsImage image={item.image} containerClass="hero-carousel__item__image" />
                        {(item.textHeading || item.actionLink) && (
                            <div className="hero-carousel__item__box">
                                {item.textHeading && <h2>{item.textHeading}</h2>}
                                {item.actionLink && (
                                    <CtaButton link={item.actionLink} buttonColor={item.actionLinkBackgroundColor} />
                                )}
                            </div>
                        )}
                    </div>
                ))}
            </Carousel>
        </div>
    )
}

export default HeroCarousel
